import {FormattedMessage} from "react-intl";
import {sortCaret} from "../../../../../_metronic/_helpers";
import {TagsFormatter} from "./partials";
import * as columnFormatters from "../../../CrudFormPage/table/column-formatters";
import React, {Fragment} from "react";
import {HighlightedTextSearch} from "../../partials";


export const columns = [
    {
        dataField: 'id',
        text: <FormattedMessage
            id="PTBP.COMMON.ID"
            defaultMessage="Id"
        />,
        sort: true,
        sortCaret
    },
    {
        dataField: 'name',
        text: <FormattedMessage
            id="PTBP.SCHOOL.REFERER"
            defaultMessage="Referente"
        />,
        sort: true,
        sortCaret,
        formatter: (data, row) => {
            return <Fragment>
                <small>
                    <HighlightedTextSearch
                        text={data}
                    />
                </small>
                <div>
                    <HighlightedTextSearch text={`${row?.referer?.first_name} ${row?.referer?.last_name}`}/>
                </div>
            </Fragment>
                ;
        }
    },
    {
        dataField: 'tags',
        text: <FormattedMessage
            id="PTBP.COMMON.TAGS"
            defaultMessage="Stato"
        />,
        sort: true,
        formatter: TagsFormatter
    },
    {
        dataField: "action",
        text: <FormattedMessage id="PTBP.PRODUCTS_PAGE.TABLE.COLUMNS.ACTIONS"/>,
        formatter: columnFormatters.ActionsColumnFormatter,
        classes: "text-right pr-0",
        headerClasses: "text-right pr-3",
        style: {
            minWidth: "100px",
        },
    },
];
